import { FormBuilder, FormGroup } from '@angular/forms';
import { APIService } from 'src/app/core/api/general.service';
import { SelectInput } from 'src/app/core/models/models';
import { ExchangeSegment, OperatingCarrier } from 'src/app/core/models/voluntary-change.model';
import { Observable, Subscription } from 'rxjs';
import { State } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-flight-change',
  templateUrl: './flight-change.component.html'
})
export class FlightChangeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id: string;
  @Input() title: string;
  @Input() showEditCabin = true;
  @Input() isInvoluntary: boolean;
  @Input() flight: ExchangeSegment;
  @Input() isSubmitted: boolean;
  @Input() isException: boolean = false;
  @Input() errorDates: boolean;
  @Input() cabinTypes: SelectInput[];
  @Input() showAirlines = false;
  @Input() enableCarrier: boolean;

  @Output() flightChange = new EventEmitter<ExchangeSegment>();

  subscriptions = new Subscription();

  store$: Observable<State>;
  airlines: OperatingCarrier[] = [];
  form: FormGroup;
  inputDisabled = false;
  checkboxVisible = true;

  constructor(
    private fb: FormBuilder,
    private generalService: APIService,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.buildForm();
    this.store$ = this.store.pipe();
    this.validateInputsDisabled();
    if (this.showAirlines) {
      this.getAirlines();
    }
  }

  validateInputsDisabled(): void {
    this.subscriptions.add(
      this.store$.subscribe((store) => {
        this.inputDisabled = this.isInvoluntary && !store.searchResult.exceptionMode;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.showAirlines?.currentValue) {
      this.getAirlines();
    }
  }

  buildForm() {
    const airportName = !!this.flight.departure.airportName
      ? this.flight.departure.airportName
      : '';
    this.form = this.fb.group({
      airportName: [{ value: airportName, disabled: true }]
    });
  }

  onChangeDate(event): void {
    this.flight.departureDateTime = event;
    this.flightChange.emit(this.flight);
  }

  airlinesSelected(event: OperatingCarrier[]): void {
    if (this.enableCarrier) {
      this.flight.operatingCarriers = event;
    } else {
      this.flight.operatingCarrier = event[0];
    }
  }

  private getAirlines(): void {
    this.subscriptions.add(
      this.generalService.getAirlines().subscribe((response) => {
        this.airlines = response.body.map((a) => ({
          name: a.parameter.name,
          code: a.parameter.iataCode,
          label: `${a.parameter.iataCode || ''} - ${a.parameter.name || ''}`
        }));
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
